<template>
  <div>
    <el-dialog :visible.sync="modals" :width="isMobile ? '100%' : '540px'" :title="titleFrom"  @closed="clearFrom"  :close-on-click-modal="false" append-to-body>
      <el-form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-width="100px" @submit.native.prevent v-loading="spink">
        <el-row :gutter="24">
			
		  <el-col >
		    <el-form-item label="二维码类型" prop="type">
		        <el-radio-group v-model="formValidate.type">
		            <el-radio :label="1">个微</el-radio>
		            <el-radio :label="2">企微</el-radio>
		          </el-radio-group>
		  		
		    </el-form-item>
		  </el-col>
		  
          <el-col >
            <el-form-item :label="'账户标识'" prop="account">
                <el-input
				  
                  v-model="formValidate.account"
                  :placeholder="'请输入二维码的唯一标识'"
                >
                </el-input>
				<div class="tips-info">用于区分二维码，建议使用微信号</div>
            </el-form-item>
          </el-col>
		  
		  <el-col >
		    <el-form-item label="二维码" prop="qrcode">
		        <upload-image v-model="formValidate.qrcode"></upload-image>
		    </el-form-item>
		  </el-col>
		  
		  <el-col>
		    <el-form-item label="昵称" prop="nickname">
		        <el-input
		          v-model="formValidate.nickname"
		          placeholder="请输入二维码的昵称"
		        >
		        </el-input>
		  		<!-- <div class="tips-info">无实际作用，仅作保存</div> -->
		    </el-form-item>
		  </el-col>
		  
		  <el-col>
		    <el-form-item label="绑定手机号" prop="mobile">
		        <el-input
		          v-model="formValidate.mobile"
		          placeholder="请输入二维码绑定的手机号"
		        >
		        </el-input>
		  		<div class="tips-info">无实际作用，仅作保存</div>
		    </el-form-item>
		  </el-col>
		  <el-col>
		    <el-form-item label="登录密码" prop="password">
		        <el-input
		          v-model="formValidate.password"
		          placeholder="请输入二维码的登录密码"
		        >
		        </el-input>
		  		<div class="tips-info">无实际作用，仅作保存</div>
		    </el-form-item>
		  </el-col>
		  
		  <el-col >
		    <el-form-item label="备注" prop="password">
		        <el-input
				  type="textarea"
		          v-model="formValidate.remark"
		          placeholder="请输入备注"
		        >
		        </el-input>
		    </el-form-item>
		  </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleReset">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('formValidate')" :disabled="loading">提 交</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { wechatAddApi ,wechatInfoApi } from '@/api/setting/wechat';
import uploadImage from '@/components/zuoy/uploadImage';
import help from '@/components/zuoy/help'
export default {
  name: 'createFrom',
  data() {
    return {
      grid: {
        xl: 12,
        lg: 12,
        md: 24,
        sm: 24,
        xs: 24,
      },
	  admins:[],
	  spink:false,
	  loading:false,
      modals: false,
	  titleFrom:'编辑二维码',
	  wecomIsOpen:0,
	  formValidate:{
		type:1,
		account:'',
		qrcode:'',
		nickname:'',
		mobile:'',
		password:'',
		remark:'',
		admin_id:''
	  },
	  
      ruleValidate: {
		type: [{ required: true, message: '请选择二维码类型', trigger: 'change' }],
        account: [{ required: true, message: '请输入', trigger: 'blur' }],
		qrcode: [{ required: true, message: '请上传二维码', trigger: 'change' }],
		nickname: [{ required: true, message: '请输入二维码的昵称', trigger: 'blur' }],
      },
    };
  },
  watch: {
    
  },
  computed: {
    ...mapState('media', ['isMobile']),
  },
  components: { uploadImage ,help},
  mounted(){
	this.wecomIsOpen = this.$store.state.cfg.configs.wecomIsOpen
  },
  methods: {
    
	
	init(id = 0)
	{
		if(id){
			this.getInfo(id)
		}
	},
    
    // 提交
    handleSubmit(name) {
      
      this.loading = true;
	  
	  this.$refs[name].validate((valid) => {
	    if (valid) {
	      wechatAddApi(this.formValidate)
	        .then(async (res) => {
	          this.$message.success(res.msg);
	          this.modals = false;
	          this.$emit('getList');
	      	  this.loading = false;
			  this.clearFrom();
	        })
	        .catch((res) => {
	          this.loading = false;
	          this.$message.error(res.msg);
	        });
	    } else {
	  	  this.loading = false;
	      return false;
	    }
	  });
	  
      
    },
    
	
	getInfo(id)
	{
		this.spink = true;
		wechatInfoApi(id)
		  .then(async (res) => {
			if(res.data.admin_id == 0){
				res.data.admin_id = '';
			}
			this.formValidate = res.data;
			this.spink = false;
		  })
		  .catch((res) => {
		    this.spink = false;
		    this.$message.error(res.msg);
		  });
	},
	
	handleReset() {
	  this.modals = false;
	  this.clearFrom();
	},
	
	// 清除表单数据
	clearFrom() {
	  this.formValidate = Object.assign({}, this.$options.data().formValidate);
	},
	
	
	
  },
  created() {
  },
};
</script>

<style scoped>

</style>
